<script setup lang="ts">
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue";
import { type Radius, borderRadiusOptions } from "./index";
const borderRadius = defineModel<Radius>({
    default: "6px",
});
</script>
<template>
    <div>
        <p class="mt-4 text-lg font-medium">
            {{ $t("configurator.choose_border_radius") }}
        </p>

        <RadioGroup
            v-model="borderRadius"
            :default-value="borderRadius"
            class="mt-2"
        >
            <RadioGroupLabel class="sr-only">{{
                $t("configurator.choose_border_radius")
            }}</RadioGroupLabel>
            <div class="gap-2 flex">
                <RadioGroupOption
                    v-for="option in borderRadiusOptions"
                    :key="option.radius"
                    v-slot="{ active, checked }"
                    as="template"
                    :value="option.radius"
                >
                    <div
                        :class="[
                            active ? 'ring-iron-700 ring-2' : '',
                            checked
                                ? 'bg-white ring-z-primary-500 ring-2'
                                : 'bg-white text-iron-900 ring-iron-300 hover:bg-iron-50 ring-1',
                            'rounded-md px-4 py-2 text-sm font-semibold flex items-center justify-center uppercase',
                        ]"
                        :style="{
                            borderRadius: option.radius,
                        }"
                    >
                        <RadioGroupLabel as="span">{{
                            option.name
                        }}</RadioGroupLabel>
                    </div>
                </RadioGroupOption>
            </div>
        </RadioGroup>
    </div>
</template>
.
